import { useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { HiDotsHorizontal } from "react-icons/hi";
import { FaCalendarDay, FaToggleOff, FaToggleOn } from "react-icons/fa";

import { CustomLoader } from '../../../services/Reducer.js'
import Add_table from '../Operator/Add_table.js'
import Edit from '../Operator/Edit.js'
import Delete from '../../../components/Delete.js';
import apiClient from '../../../api/apiClient.js';
import { RiFileExcel2Line } from 'react-icons/ri';
import AFFilter from './Filter.js';
import authServices from '../../../services/AuthServices.js';
import { TfiReload } from "react-icons/tfi";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const OpraterTable = () => {

  const [running, setrunning] = useState(false);

  const [LogicalFlag, setLogicalFlag] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };


  //****************************************   this is for Edit modal    ***********************************************************

  const [editModal, seteditModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const toggleeditModal = (invoiceId) => {
    setSelectedInvoice(invoiceId);
    seteditModal(!editModal);
  };


  //****************************************   GetAll Data Fetch ka function  ****************************************************

  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const loader = (display) => { dispatch(CustomLoader(display)) }

  const [Records, setRecords] = useState([]);

  const [currentPage, setCurrentPage] = useState(0); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total pages
  const itemsPerPage = 8; // Number of items per page

  const token = authServices.getToken();

  const fetchRecords = async (page) => {

    try {
      setIsToggled(false)
      setAFFromDate(null)
      setAFToDate(null)

      loader('enable');
      const response = await apiClient.get(`/api/admin/users/getByUserType?userType=operator&pageNumber=${page}&pageSize=${itemsPerPage}`, {

        headers: {
          'access_token': token,
        },
      });
      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      loader('disable');
    }

  };

  //***********************************************  Date Picker useEffect *******************************************************
  useEffect(() => {
    loader('disable');

    if (inputRef.current) {
      const fp = flatpickr(inputRef.current, {
        mode: "range",
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            setSelectedDate(selectedDates); // Set the selected date range

            setLogicalFlag(true);
            setIsToggled(false)
          }
        },
      });

      return () => {
        fp.destroy();
      };


    }
  }, []);


  // Pagination handlers
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage); // Update page
  };


  // Pagination component
  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];

    // Add first 2 pages
    for (let i = 0; i < Math.min(2, totalPages); i++) {
      pages.push(i);
    }

    // Add the current page if it's between first 2 and last 2 pages
    if (currentPage > 1 && currentPage < totalPages - 2) {
      pages.push(currentPage);
    }

    // Add last 2 pages
    for (let i = Math.max(totalPages - 2, 2); i < totalPages; i++) {
      pages.push(i);
    }


    // Previous button condition
    const previousPage = () => {
      if (currentPage > 0) {
        onPageChange(currentPage - 1);
      }
    };

    // Next button condition
    const nextPage = () => {
      if (currentPage < totalPages - 1) {
        onPageChange(currentPage + 1);
      }
    };

    //********************************  pagination Buttons Next & Previous  ***********************************************************
    return (
      <nav>
        <ul className="pagination">

          {/* Previous Button */}
          <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
            <button onClick={previousPage} className="page-link">
              Previous
            </button>
          </li>

          {pages.map((page) => (
            <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
              <button onClick={() => onPageChange(page)} className="page-link">
                {page + 1}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
            <button onClick={nextPage} className="page-link">
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };


  //*********************************************  flatpickr code Date filter  *******************************************************


  const [selectedDate, setSelectedDate] = useState([]);

  const [AFFromDate, setAFFromDate] = useState(null);
  const [AFToDate, setAFToDate] = useState(null);

  const formatDate = (date) => {

    if (!date) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;

  };

  const Flatpickr_Filter = async (page) => {

    const formattedFromDate = formatDate(new Date(selectedDate[0])),
      formattedToDate = formatDate(new Date(selectedDate[1]));
    setIsToggled(false)
    setAFFromDate(null)
    setAFToDate(null)

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }

    try {
      setRecords([]);

      loader('enable');

      const response = await apiClient.get(`/api/admin/users/RegdateRangePagedWithPagination?fromDate=${formattedFromDate}&toDate=${formattedToDate}&pageNumber=${page}&pageSize=${itemsPerPage}&userType=${'operator'}`
        , {

          headers: {
            'access_token': token,
          },

        });
      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);

      }
      else {
        console.log(response.data.message)
      }

    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      setLogicalFlag(false);
      loader('disable');

    }

  };



  // *******************************************************************************************************************
  // Delete List Records


  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const handleDeleteClick = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setOpenModal(true); // Open the modal when delete is clicked
  };

  const handleConfirmDelete = async (invoiceId) => {
    try {
      loader('enable');
      const response = await apiClient.delete(`/api/admin/users/${selectedInvoiceId}`, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {
        toast.success("oprater deleted successfully")
      }
      else {
        toast.error(response.data.message)
        console.log(response.data.message)
      }

    } catch (error) {
      toast.error(error.response.data.message)
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    } finally {
      fetchRecords(currentPage);
      loader('disable');
      setOpenModal(false);
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal if user cancels
  };

  // Excel File Downlode

  const ExcelFileDownload = async () => {
    try {
      loader('enable');
      const response = await apiClient.get(`/api/admin/users/download`, {
        responseType: 'blob',
        params: {
          userType: "operator",

        },
        headers: {
          'access_token': token,
        },

      });
      // if (response.data.Status === "SUCCESS") {

      // Create a link to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Set the file name you want to download as
      link.setAttribute('download', 'operator.xlsx'); // Change the file name if needed
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      link.remove();

      // }
      // else {
      //   console.log(response.data.message)
      // }

    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      loader('disable');
    }
  };



  //**********************************************  This is for Advance filter *******************************************************

  const [FilterModal, setFilterModal] = useState(false);

  const [selectedOption, setselectedOption] = useState(null);
  const [inputValue, setinputValue] = useState(null);
  const [CheckBoxValue, setCheckBoxValue] = useState(null);

  const toggleFilterModal = () => {
    setFilterModal(!FilterModal);
  };

  const handleSendDataToParent = (fromDate, toDate, column, value, selectedCheckboxValue) => {
    setIsToggled(false)
    setAFFromDate(fromDate)
    setAFToDate(toDate)
    setselectedOption(column)
    setinputValue(value)
    setCheckBoxValue(selectedCheckboxValue)

    setSelectedDate([]);
    setLogicalFlag(true);

  };

  const applyFilter = async (page) => {

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }


    try {
      setTotalPages(0);
      setRecords([]);

      loader('enable');
      const pageNumber = page;
      const pageSize = itemsPerPage;

      const fromDate = AFFromDate;
      const toDate = AFToDate;
      const column = selectedOption;
      const value = inputValue;
      const status = CheckBoxValue;
      const userType = "operator";

      const response = await apiClient.get(`/api/admin/users/filter`, {
        params: {
          userType,
          pageNumber,
          pageSize,
          fromDate,
          toDate,
          column,
          value,
          status,
        },

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      setLogicalFlag(false);
      loader('disable');
    }

  };

  // console.log("current page : ", currentPage);


  // *************************************************  This For CheckBox  **********************************************************

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = displayedData.map(invoice => invoice.id);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (event, id) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== id));
    }
  };

  // console.log("oprater Checkbox : ", selectedItems)


  const updateMultipleUsers = async () => {
    const token = authServices.getToken();

    // IDs ko payload format me transform karna
    const paylode = selectedItems.map(id => ({
      id: id,
      approval: "approved"
    }));

    try {
      const response = await apiClient.put(`/api/admin/users/updateMultiple`, paylode, {
        headers: {
          "Content-Type": "application/json",
          access_token: token,
        },
      });
      console.log("Response:", response.data);
    } catch (error) {
      console.error("Error updating users:", error);
    }
    finally {
      {
        setSelectedDate([]);
        setAFFromDate(null);
        setAFToDate(null);

        if (isToggled === false) {

          fetchRecords(currentPage);
        } else {
          fetchApprovedOperator(currentPage)
        }
      }
    }
  };


  // *******************************************************************************************************************************

  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    setSelectedDate([]);
    setAFFromDate(null)
    setAFToDate(null)
    setIsToggled(!isToggled);
    setLogicalFlag(true);

  };

  const fetchApprovedOperator = async (page) => {
    const token = authServices.getToken();

    try {
      setrunning(true)
      if (LogicalFlag) {
        page = 0;
        setCurrentPage(0);
      }
      const response = await apiClient.get(`/api/admin/users/searchByApproval`,
        {
          params: {
            approval: "pending",
            pageNumber: page,
            pageSize: itemsPerPage,
            userType: "operator",
          },
          headers: {
            access_token:
              token,
          },
        }
      );

      if (response.data.Status === "SUCCESS") {
        // toast.success("Success searchByApproval!");

        setRecords(response.data.data.records); // Adjust this based on your API's response structure
        setTotalPages(response.data.data.totalPages);
      }
      else {
        // toast.error("Error searchByApproval!");
      }
    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);

    } finally {
      setrunning(false)
      setLogicalFlag(false);
    }
  };


  useEffect(() => {

    if (isToggled === false) {
      if (selectedDate[0] && selectedDate[1]) {
        Flatpickr_Filter(currentPage);

      }
      else if (AFFromDate && AFToDate) {
        applyFilter(currentPage);

      }
      else {
        fetchRecords(currentPage);
      }
    } else {
      fetchApprovedOperator(currentPage)
    }
    setSelectedItems([])
  }, [isToggled, currentPage, AFFromDate, AFToDate, selectedDate]);


  // ********************************************************************************************************************************

  const displayedData = Records;

  // Reset filter and fetch original data
  const resetFilter = () => {
    setSelectedDate([]);
    fetchRecords(0);
    setCurrentPage(0);
    setAFFromDate(null)
    setAFToDate(null)

    // Reset flatpickr calendar dates
    if (inputRef.current && inputRef.current._flatpickr) {
      inputRef.current._flatpickr.clear();
    }
  };

  return (

    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <div className="mb-4">

                <Add_table show={showModal} toggle={toggleModal} refreshData={fetchRecords} AddcurrentPage={currentPage} />
                <Edit edit={editModal} toggle_Edit={toggleeditModal} invoiceId={selectedInvoice}
                  refreshData={fetchRecords} AddcurrentPage={currentPage} />

                <AFFilter
                  Filter={FilterModal}
                  toggle_Filter={toggleFilterModal}
                  SendDataToParent={handleSendDataToParent}

                />

                <button
                  onClick={toggleModal}
                  type="button"
                  className={`btn btn-light waves-effect waves-light ${selectedItems.length === 0 ? '' : 'd-none'
                    }`}
                >

                  +&nbsp;ADD
                </button>

                <button
                  onClick={updateMultipleUsers}
                  type="button"
                  className={`btn btn-primary waves-effect waves-light ${selectedItems.length > 0 ? '' : 'd-none'
                    }`}
                >
                  <span className=''>Approval</span>
                </button>

              </div>
              <div className="d-flex align-items-center gap-1 mb-4">

                <div className="d-flex flex-wrap gap-2 mt-2">
                  <input
                    type="checkbox"
                    id={'switch1'}
                    switch="none"
                    defaultChecked=""
                    onClick={handleToggle}
                    disabled={running}
                  />

                  <label
                    htmlFor="switch1"
                    data-on-label={isToggled ? 'Pending' : 'All'}
                    data-off-label={isToggled === false ? 'All' : 'Pending'}
                    style={{ width: "74px", display: "inline-block", textAlign: "center" }}
                  />
                </div>


                {/* <span style={{ fontSize: '14px', marginRight: '5px', fontFamily: 'Arial', }} className=''>
                  {isToggled ? 'Pending' : 'All'}
                </span>
                <button className="input-group-text" style={{ fontSize: '19px' }} id="date1" 
                // onClick={handleToggle}
                >

                  {isToggled ? <FaToggleOn /> : <FaToggleOff />}
                </button> */}

                <div className="input-group datepicker-range">
                  <input
                    ref={inputRef}
                    className="form-control flatpickr-input input"
                    type="text"
                    value={
                      selectedDate.length === 2 && selectedDate[0] && selectedDate[1]
                        ? `${formatDate(selectedDate[0])} - ${formatDate(selectedDate[1])}`
                        : "" // Empty input initially
                    }
                    onChange={(e) => {
                      const dateRange = e.target.value.split(" - ");
                      const startDate = dateRange[0] ? new Date(dateRange[0].split('-').reverse().join('-')) : null;
                      const endDate = dateRange[1] ? new Date(dateRange[1].split('-').reverse().join('-')) : null;

                      setSelectedDate([startDate, endDate]);

                    }}
                    placeholder="Filter By Registration Date"
                  />

                  <button className="input-group-text" id="date1" onClick={resetFilter}>
                    <TfiReload />
                  </button>

                </div>
                <div className="dropdown">
                  <a
                    className="btn btn-link text-muted py-1 font-size-16 shadow-none dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    < HiDotsHorizontal />
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end">

                    <li>
                      <a className="dropdown-item" onClick={() => toggleFilterModal()}>
                        Filter
                      </a>
                    </li>

                    {/* <li>
                      <button className="dropdown-item" onClick={ExcelFileDownload}>
                        <RiFileExcel2Line
                          style={{
                            fontSize: '20px',
                            marginLeft: '-0.50vw',
                            marginRight: '0.50vw',
                            marginTop: '-0.10vw',
                          }}
                        />
                        Excel File Download
                      </button>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            {/* end row */}
            <div className="table-responsive ">
              <table
                className="table table-bordered align-middle datatable dt-responsive table-check nowrap text-center"
                style={{
                  borderCollapse: "collapse",
                  borderSpacing: "0 8px",
                  width: "100%"
                }}
              >
                <thead className='table-light'>
                  <tr className="bg-transparent">
                    <th style={{ width: 5 }}>

                      <div className="form-check font-size-16">
                        <input
                          type="checkbox"
                          name="check"
                          className="form-check-input"
                          id="checkAll"
                          onChange={handleSelectAll}
                          checked={selectedItems.length === displayedData.length}
                        />
                        <label className="form-check-label" htmlFor="checkAll" />
                      </div>

                    </th>
                    {/* <th style={{ width: 100 }}>_ID_</th> */}
                    <th style={{ width: 100 }}>Name</th>
                    <th style={{ width: 100 }}>Email</th>
                    {/* <th style={{ width: 100 }}>EntityName</th> */}
                    <th style={{ width: 100 }}>Mobile</th>
                    {/* <th style={{ width: 100 }}>Password</th> */}
                    <th style={{ width: 100 }}>&nbsp;&nbsp;Parent&nbsp;&nbsp;</th>
                    <th style={{ width: 100 }}>Balance</th>
                    <th style={{ width: 100 }}>Balance&nbsp;Cap</th>
                    <th style={{ width: 100 }}>Register&nbsp;Date</th>
                    <th style={{ width: 100 }}>Pan&nbsp;Number</th>
                    {/* <th style={{ width: 100 }}>Aadhaar Name</th> */}
                    {/* <th style={{ width: 100 }}>Pan Name</th> */}
                    {/* <th style={{ width: 100 }}>Aadhaar Number</th> */}
                    {/* <th style={{ width: 100 }}>Aadhaar Mask</th> */}
                    {/* <th style={{ width: 100 }}>Status</th> */}
                    <th style={{ width: 100 }}>Approval</th>
                    {/* <th style={{ width: 100 }}>User Type</th> */}
                    {/* <th style={{ width: 100 }}>Unique</th> */}
                    <th style={{ width: 100 }}>GST&nbsp;Number</th>
                    <th style={{ width: 100 }}>Tan&nbsp;Number</th>
                    <th style={{ width: 100 }}>&nbsp;&nbsp;&nbsp;&nbsp;Address&nbsp;&nbsp;&nbsp;&nbsp;</th>
                    {/* <th style={{ width: 100 }}>Port</th> */}
                    {/* <th style={{ width: 100 }}>OTP</th> */}

                    <th style={{ width: 100 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedData.length > 0 ? (
                    <>
                      {displayedData.map(invoice => (
                        <tr key={invoice.id}>
                          <td>

                            <div className="form-check font-size-16">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`check-${invoice.id}`}
                                checked={selectedItems.includes(invoice.id)}
                                onChange={(e) => handleSelectItem(e, invoice.id)}
                              />
                              <label className="form-check-label" htmlFor={`check-${invoice.id}`} />
                            </div>

                          </td>
                          {/* <td>
                            <a
                              className="text-body fw-medium"
                            >{invoice.id}
                            </a>
                          </td> */}
                          <td>{invoice?.name || '--'}</td>
                          <td>{invoice?.email || '--'}</td>
                          {/* <td>{invoice?.entityName || '--'}</td> */}
                          <td>{invoice?.mobile || '--'}</td>
                          {/* <td>{invoice?.password || '--'}</td> */}
                          <td>{invoice?.parentId && invoice?.parentId?.name ? invoice?.parentId?.name : '--'}</td>
                          <td>{invoice?.balance ? invoice?.balance.toFixed(2) : '0.00'}</td>
                          <td>{invoice?.balanceCap ? invoice?.balanceCap.toFixed(2) : '0.00'}</td>
                          <td>{invoice?.regDate || '--'}</td>
                          <td>{invoice?.panNumber || '--'}</td>
                          {/* <td>{invoice?.nameOnAadhaar || '--'}</td> */}
                          {/* <td>{invoice?.nameOnPan || '--'}</td> */}
                          {/* <td>{invoice?.aadharNumber || '--'}</td> */}
                          {/* <td>{invoice?.aadharMask || '--'}</td> */}
                          {/* <td>{invoice?.status || '--'}</td> */}
                          <td>{invoice?.approval || '--'}</td>
                          {/* <td>{invoice?.userType || '--'}</td> */}
                          {/* <td>{invoice?.uniqueId || '--'}</td> */}
                          <td>{invoice?.gstNo || '--'}</td>
                          <td>{invoice?.tanNumber || '--'}</td>
                          <td>
                            <details>
                              <summary>View</summary>
                              {invoice?.address || '--'}
                            </details>
                          </td>
                          {/* <td>{invoice?.portId?.name || '--'}</td> */}
                          {/* <td>{invoice?.otp || '--'}</td> */}

                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                < HiDotsHorizontal />
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end">
                                <li>

                                  <button
                                    onClick={() => toggleeditModal(invoice.id)}
                                    type="button"
                                    className="btn waves-effect waves-light dropdown-item"
                                  >

                                    <i className="dropdown-item" /> Edit
                                  </button>

                                </li>

                                <li>
                                  <button className="btn waves-effect waves-light dropdown-item"
                                    onClick={() => handleDeleteClick(invoice.id)}
                                  >
                                    Delete
                                  </button>
                                  <Delete
                                    open={openModal}
                                    handleClose={handleCloseModal}
                                    handleConfirm={handleConfirmDelete}
                                    message="Are you sure you want to delete this invoice ?"
                                  />
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={20}>
                        <p className="text-center" >Record Not Found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* end table responsive */}

            <div className='d-flex flex-row justify-content-end'>
              Showing {currentPage + 1} In to {totalPages} Entries
            </div>

            {/* Pagination */}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />

          </div>

          {/* end card body */}
        </div>
        {/* end card */}
      </div>
      {/* end col */}
    </div>

  );
};

export default OpraterTable;
